module.exports = __webpack_public_path__ + "static/media/zing_2x2.b2c47a77.jpg";